module.exports = __webpack_public_path__ + "img/s350l.d5810462.png";